import fetch from "node-fetch";

import { BACKEND_URL } from "config/constants";

// Status enum
export const status = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error"
};

// Actions
export const types = {
  GET_ASYNC: "MAIN/SHOWROOM/GET_ASYNC",
  SET: "MAIN/SHOWROOM/SET",
  SET_CURRENT_PRODUCT_ID: "MAIN/SHOWROOM/SET_CURRENT_PRODUCT_ID"
};

// Reducer
export const initialState = {
  status: status.LOADING,
  currentProductId: null,
  showroom: {},
  categories: []
};

function getAsync(showroomDir) {
  return dispatch => {
    dispatch(actions.set(status.LOADING));
    let url = `${BACKEND_URL}/v1/showroom-info/${showroomDir}`;
    fetch(url, {
      method: "GET"
    })
      .then(res => {
        res.json().then(info => {
          dispatch(actions.set(status.SUCCESS, info));
          if (info.categories && info.categories.length > 0) {
            const firstCategory = info.categories[0];
            const products = firstCategory.Products;
            let firstProduct;
            if (products) firstProduct = products[0];
            if (firstProduct)
              dispatch(actions.setCurrentProductId(firstProduct.id));
          }
        });
      })
      .catch(err => {
        dispatch(actions.set(status.ERROR));
      });
  };
}

const showroom = (state = initialState, action) => {
  switch (action.type) {
    case types.SET:
      let info = action.payload.info;
      return { ...state, status: action.payload.status, ...info };
    case types.SET_CURRENT_PRODUCT_ID:
      return { ...state, currentProductId: action.payload.id };
    default:
      return state;
  }
};

export default showroom;

// Action creatorss
export const actions = {
  set: (status, info) => ({
    type: types.SET,
    payload: { status, info }
  }),
  setCurrentProductId: id => ({
    type: types.SET_CURRENT_PRODUCT_ID,
    payload: { id }
  }),
  getAsync
};



// WEBPACK FOOTER //
// ./src/reducers/main/showroom.js